export type SubSessionChangeListener = (subSessionId: string | null) => void;

let confirmedSubSessionId: string | null = null;
const listeners = new Set<SubSessionChangeListener>();

/**
 * This tab's confirmed sub-session id, for the request helpers to send. Null while a claim
 * is pending, so a tab that may be a copy never sends another tab's id.
 */
export const currentSubSession = (): string | null => confirmedSubSessionId;

/**
 * Calls `listener` whenever `currentSubSession()` changes, not on subscribe. A change to null
 * means unknown for now (e.g. during a re-claim), not a new sub-session.
 */
export const onSubSessionChange = (listener: SubSessionChangeListener): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

/** Only for the sub-session module itself (the bridge). */
export const setCurrentSubSession = (subSessionId: string | null): void => {
  if (subSessionId === confirmedSubSessionId) {
    return;
  }

  confirmedSubSessionId = subSessionId;
  [...listeners].forEach((listener) => {
    try {
      listener(subSessionId);
    } catch (error) {
      // One faulty listener must not stop the others or the id adoption.
      // Rethrown asynchronously so it still reaches the error reporting.
      setTimeout(() => {
        throw error;
      });
    }
  });
};
